import * as React from 'react';

import { FlashMessageType } from '~/src/atomic/mol.flash-message';

export interface FlashMessageContextContent {
  type?: FlashMessageType;
  hidden: boolean;
  content?: string;
}

export interface FlashMessageContextState {
  message: FlashMessageContextContent;
  showMessage: (type: FlashMessageType, content: string) => void;
  hideMessage: () => void;
}

export const FlashMessageContext = React.createContext<FlashMessageContextState>(null);
